import React from "react";
import { CtaLink } from "../../Elements";
import { PanelWrapper, Heading, ListWrapper } from "./style";

const QuickLinksPanel = ({ header, navigations }) => {
	const renderLinks = (navigations) => {
		return navigations.map(({ name, link }, index) => {
			return (
				<li key={index}>
					<CtaLink
						Link={link.link}
						type={link.type}
						value={link.link}
						target={link.target}
						className="link"
						key={`${name}-${index}`}
					>
						{name}
					</CtaLink>
				</li>
			);
		});
	};

	return (
		<PanelWrapper>
			<Heading>{header}</Heading>
			<ListWrapper>{renderLinks(navigations)}</ListWrapper>
		</PanelWrapper>
	);
};

export default QuickLinksPanel;
